import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  BrowserRouter, Routes, Route } from "react-router-dom";

import CrmHeader from './Components/CrmHeader';
import CrmLeftColumn from './Components/CrmLeftColumn';
import CrmProductList from './Components/CrmProductList';
import CrmProductModal from "./Components/CrmProductModal";


function App() {

  return (

    <div className="App">

        <BrowserRouter>
            <CrmHeader />
            <div className="Content">
                <CrmLeftColumn />
                <Routes>
                    <Route path={'/'} element={ <CrmProductList /> } />
                    <Route path={'/product-list'} element={ <CrmProductList /> } />
                    <Route path={'/product-create'} element={ <CrmProductModal /> } />
                </Routes>
            </div>
        </BrowserRouter>
    </div>
  );
}

export default App;
